import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { TiCancel } from "react-icons/ti";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";

const Freezing_Interfaces: React.FC = () => {
  return (
    <>
      <Row>
        <Col>
          <Title title={"تجميد الواجهات"} />
        </Col>
      </Row>
      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> اسم الواجهة</td>
                <td>العمليات</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>انشاء فصل دراسي</td>
                <td>
                  <div className="flex justify-evenly">
                    <div
                      id="info-emp"
                      className="flex justify-center cursor-pointer"
                    >
                      <Link to="single_student">
                        <TiCancel size={40} className="text-[#c433a4]" />
                      </Link>
                      <Tooltip
                        anchorSelect="#info-emp"
                        style={{ background: "#475569" }}
                      >
                        <button> تجميد </button>
                      </Tooltip>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
};

export default Freezing_Interfaces;
